import {computed} from "mobx";

declare var $:any;

import * as React from 'react';
import { observer } from 'mobx-react';
import { FeedItemContainer } from './FeedItemContainer';
import { FeedItemContent } from './FeedItemContent';
import { UIState } from 'data/UIState';
import {PhotoRendered} from "../../PhotoRendered";
import {Photo} from "../../Photo";
import {StringHelpers} from "shared/StringHelpers";
import {Transport} from "data/transport";
import {HeaderLevelCorrectedContent} from "components/feed/FeedItem/HeaderLevelCorrectedContent";
import {FeedItemContextType} from "components/feed/FeedItem/FeedItem";
import {handleSpacePressed} from "utils";
import {feedItemHasFullPost} from "data/entities/FeedItemEntity";

interface IFeedItemComplexProps {
  feedItem:any;
  user:any;
  updateFeedItem:(feedItem:any)=>void;
  openFullPostModal:()=>void;
  feedItemContext:FeedItemContextType;
}

@observer
export class FeedItemComplex extends React.Component<IFeedItemComplexProps> {

  handleViewFullPost = (e) => {
    let feedItemUpdates:any = null;

    if(false==this.props.feedItem.read) {
      feedItemUpdates = { read: true};
    }


    if(this.props.feedItem._post && this.props.feedItem._post.pointValue>0 && this.props.feedItem._post.awardPointsForReading && !this.props.feedItem.pointsAwarded) {
      if(!feedItemUpdates) {
        feedItemUpdates = {};
      }
      feedItemUpdates.pointsAwarded = this.props.feedItem._post.pointValue;
    }
    
    if(feedItemUpdates){
      $.ajax({
        contentType:"application/json; charset=utf-8",
        dataType:'json',
        headers: { 'Authorization':'Token '+localStorage.getItem('token') },
        type:'PUT',
        url: Transport.URL("/feed/items/"+this.props.feedItem._id),
        data:JSON.stringify(feedItemUpdates)
      })
      .done((_feedItem)=>{
        const feedItem = this.props.feedItem;
        feedItem.read = _feedItem.read;
        feedItem.pointsAwarded = _feedItem.pointsAwarded?_feedItem.pointsAwarded:0;
        feedItem.pointsAwardedDate = _feedItem.pointsAwardedDate;
        this.props.updateFeedItem(feedItem);
        this.props.openFullPostModal();

      })
      .error( function(jqXHR, textStatus, errorThrown ){
        //alert('Failed!');
        console.log(errorThrown);
      }); 
    } else {
      this.props.openFullPostModal();
    }
  }

  markRead = (e) => {
    e.stopPropagation();
    $.ajax({
        contentType:"application/json; charset=utf-8",
        dataType:'json',
        headers: { 'Authorization':'Token '+localStorage.getItem('token') },
        type:'PUT',
        url: Transport.URL("/feed/items/"+this.props.feedItem._id),
        data:JSON.stringify({read:true})
      })
      .done(()=>{
        var feedItem = this.props.feedItem;
        feedItem.read = true;
        this.props.updateFeedItem(feedItem);				
      })
      .error( function(jqXHR, textStatus, errorThrown ){
      }); 		
    return true;
  }

  @computed get isCheckIn() {
    return this.props.feedItem.type==='checkin';
  }

  @computed get isPoints() {
    return this.props.feedItem.type==='points';
  }

  @computed get hasFullPost() {
    return feedItemHasFullPost(this.props.feedItem);
    /*
    if(this.props.feedItem._post){
      const fullPost = StringHelpers.safeHTML(this.props.feedItem._post.fullPost);
      if(null!==fullPost) {
        return true;
      }
    }
    return false
    */
  }

  render(){
    
    let icon:any;
    const iconClassName = (this.props.feedItem.icon?this.props.feedItem.icon : (this.props.feedItem._post && this.props.feedItem._post.icon) ? this.props.feedItem._post.icon:"icon-graph-filled");

    // Is there a post associated with this feedItem
    if(this.props.feedItem._post) {
      if(this.props.feedItem._post.type=='blog'){
        let bloggerIcon = '/res_sys/blogger_face.jpg';
        if(this.props.feedItem._postAuthor){
          if(this.props.feedItem._postAuthor.avatar) {
            if(this.props.feedItem._postAuthor.avatar.indexOf('/res/')===0) {
              bloggerIcon = this.props.feedItem._postAuthor.avatar;
            } else {
              bloggerIcon = '/usercontent/'+this.props.feedItem._postAuthor.avatar;
            }
          }
          const altText = 'Post by '+this.props.feedItem._postAuthor.firstName+" "+this.props.feedItem._postAuthor.lastName;
          icon = <span className="solution" aria-hidden={true}><span className="face"><img alt={altText} src={bloggerIcon} /></span></span>;
        } else {
          icon = <span className="solution" aria-hidden={true}><span className="face"><img src={bloggerIcon} /></span></span>;
        }
      } else {
        if(this.props.feedItem._post.pointValue) {
          icon = <span className="solution">
            <i className={iconClassName} aria-hidden={true} />
            <div className="text">
              <span className={"visuallyhidden"}>{this.props.feedItem._post.pointValue} point value</span>
              <span aria-hidden={true}>{this.props.feedItem._post.pointValue} pts.</span>
            </div>
          </span>;
        } else {
          icon = <span className="solution" aria-hidden={true}><i className={iconClassName}/></span>;
        }
      }
    } else {
      icon = <span className="solution"><i className={iconClassName} aria-hidden={true} />{this.props.feedItem.pointsAwarded?<div className="text">{this.props.feedItem.pointsAwarded} pts.</div>:""}</span>;
    }


    let title = this.props.feedItem._post ? this.props.feedItem._post.title : "";
    let content = this.props.feedItem._post ? this.props.feedItem._post.content : this.props.feedItem.content;
    const collapsed = this.props.feedItem._post && this.props.feedItem._post.collapsable && ((this.props.feedItem._post.collapsedWhenRead && this.props.feedItem.read) || (this.props.feedItem._post.collapsedWhenUnread && !this.props.feedItem.read));		
    const collapsable = this.props.feedItem._post ? this.props.feedItem._post.collapsable : false;
    const commentsText = this.props.feedItem._post && this.props.feedItem._post.commenting ? " ("+this.props.feedItem._post.comments.length+" comment"+(1==this.props.feedItem._post.comments.length?"":"s")+")": "";
    const viewFullPostActionLabel = this.props.feedItem._post ? (this.props.feedItem._post.fullPostLinkTitle ? this.props.feedItem._post.fullPostLinkTitle : "VIEW FULL POST") : "VIEW FULL POST";

    let button:any;
    if(this.props.feedItem._post && this.props.feedItem._post.buttonAction) {
      let buttonAction = this.props.feedItem._post.buttonAction;

      buttonAction = buttonAction.replace("USER_EMAIL_ADDRESS", this.props.user.email);
      buttonAction = buttonAction.replace(/{{email}}/g, this.props.user.email);

      buttonAction = buttonAction.replace("USER_FIRST_NAME", this.props.user.firstName);
      buttonAction = buttonAction.replace(/{{firstName}}/g, this.props.user.firstName);

      buttonAction = buttonAction.replace("USER_LAST_NAME", this.props.user.lastName);
      buttonAction = buttonAction.replace(/{{lastName}}/g, this.props.user.lastName);

      button = <a tabIndex={0} role={'link'} href={buttonAction} target="_blank" aria-label={`${this.props.feedItem._post.buttonTitle ? this.props.feedItem._post.buttonTitle : "Go"}, opens new tab`} style={{textDecoration:"none"}}><div className="get-points">{this.props.feedItem._post.buttonTitle ? this.props.feedItem._post.buttonTitle : "Go"}</div></a>
    }

    let bottomLinkAction:string = '';
    if(this.props.feedItem._post && this.props.feedItem._post.bottomLinkAction) {
      bottomLinkAction = this.props.feedItem._post.bottomLinkAction;

      bottomLinkAction = bottomLinkAction.replace("USER_EMAIL_ADDRESS", this.props.user.email);
      bottomLinkAction = bottomLinkAction.replace(/{{email}}/g, this.props.user.email);

      bottomLinkAction = bottomLinkAction.replace("USER_FIRST_NAME", this.props.user.firstName);
      bottomLinkAction = bottomLinkAction.replace(/{{firstName}}/g, this.props.user.firstName);

      bottomLinkAction = bottomLinkAction.replace("USER_LAST_NAME", this.props.user.lastName);
      bottomLinkAction = bottomLinkAction.replace(/{{lastName}}/g, this.props.user.lastName);
    }
    
    let item3Style = {};
    let item2Style = {};
    if(button && UIState.isMobile) {
      item3Style = {
        position: 'absolute',
        bottom: '8px',
        right: '0'
      }
      item2Style = {
        marginBottom:'40px'
      }
    }

    if(this.isCheckIn) {
      title = this.props.feedItem.pointsAwarded ? "You've earned "+this.props.feedItem.pointsAwarded+" point"+(this.props.feedItem.pointsAwarded>1?"s":"") : "You've check in!";
      content = '<p>Thanks for checking in</p>';
      icon = <span className="solution"><PhotoRendered photo={new Photo(this.props.feedItem.icon)} />{this.props.feedItem.pointsAwarded?<div className="text">{this.props.feedItem.pointsAwarded} pts.</div>:""}</span>;
    }

    if(this.isPoints) {
      title = "You've earned "+this.props.feedItem.pointsAwarded+" point"+(this.props.feedItem.pointsAwarded>1?"s":"");
      content = '<p>'+this.props.feedItem.content+'</p>';
      icon = <span className="solution"><PhotoRendered photo={new Photo(this.props.feedItem.icon)} />{this.props.feedItem.pointsAwarded?<div className="text">{this.props.feedItem.pointsAwarded} pts.</div>:""}</span>;
    }

    return (
      <div>
        <FeedItemContainer completed={this.props.feedItem.completed} >
          
          {icon}

          <div style={item2Style}>					
              <FeedItemContent title={title} fromDate={this.props.feedItem.calendarStartDate} toDate={this.props.feedItem.calendarEndDate} feedItemContext={this.props.feedItemContext}>
                <HeaderLevelCorrectedContent className="text" content={content} offset={this.props.feedItemContext} />
              </FeedItemContent>
            {!this.isPoints &&
              <div className="actions">
                {this.hasFullPost  ? <a tabIndex={0} role={"link"}
                                        className="action"
                                        onKeyDown={(e)=>{ handleSpacePressed(e, this.handleViewFullPost);}}
                                        onClick={this.handleViewFullPost}>{viewFullPostActionLabel}{commentsText}</a> : "" }
                { ''!==bottomLinkAction ? <a tabIndex={0}
                                             role={"link"}
                                             className="action"
                                             onClick={this.markRead}
                                             onKeyDown={(e)=>{ handleSpacePressed(e, this.markRead );}}
                                             href={bottomLinkAction}
                                             target="_blank"
                                             aria-label={`${this.props.feedItem._post.bottomLinkTitle ? this.props.feedItem._post.bottomLinkTitle : "VIEW"}, opens new tab`}
                                          >{this.props.feedItem._post.bottomLinkTitle ? this.props.feedItem._post.bottomLinkTitle : "VIEW"}</a> : "" }
              </div>
            }
          </div>

          <div style={item3Style}>
              {button}
              {this.props.feedItem.pointsAwarded?<div className="points"><div>+</div><div><div className="circ"><div>{this.props.feedItem.pointsAwarded}</div></div></div></div>:""}							
          </div>
        
        </FeedItemContainer>
      </div>
    );
  }
}

